import { Button, DropdownMenu } from 'components/atoms';
import { youtubeRefetchDelayInMinutes } from 'constants/youtubeRefetchDelay';
import { useComponentVisible, useCountdown } from 'hooks';
import { t } from 'i18next';
import { useEffect } from 'react';
import { PiArrowsClockwise } from 'react-icons/pi';
import { IChannelSyncAll } from 'services/channel/types/query';
import { BUTTON_VARIANT } from 'types/components/button/button.interface';

interface ISyncButtonProps {
  lastSyncDate?: string;
  onSync: (method: keyof IChannelSyncAll, startCounter?: () => void) => void;
  isPending?: boolean;
  variant?: BUTTON_VARIANT
}

const ChanelSyncButton = ({
  lastSyncDate,
  variant = BUTTON_VARIANT.submit,
  onSync,
  isPending,
}: ISyncButtonProps) => {
  const { ref, isComponentVisible, handleComponentVisible } =
    useComponentVisible<HTMLDivElement>(false);

  const leftToRefetchInMinutes = lastSyncDate
    ? Math.floor(
        (new Date(lastSyncDate).getTime() +
          youtubeRefetchDelayInMinutes * 60 * 1000 -
          new Date().getTime()) /
          1000 /
          60
      )
    : 60;

  const { countdown, isCountingDown, startCounter } = useCountdown(
    leftToRefetchInMinutes * 60,
    false
  );

  useEffect(() => {
    if (lastSyncDate && leftToRefetchInMinutes > 0) {
      startCounter();
    }
  }, [leftToRefetchInMinutes, lastSyncDate, startCounter]);

  return (
    <Button
      variant={variant}
      disabled={isCountingDown || isPending }
      onClick={handleComponentVisible}
      outsideChildren={
        <DropdownMenu
          ref={ref}
          visible={isComponentVisible}
          style={{ padding: 0 }}
          justifyPosition='end'>
          <Button
            isClear
            disabled={isCountingDown || isPending}
            onClick={() => onSync('addNewVideos')}
            fullWidth>
            <Button.Text text={t('button.addNewVideos')} />
          </Button>

          <Button
            isClear
            disabled={isCountingDown || isPending}
            onClick={() => onSync('updateVideos')}
            fullWidth>
            <Button.Text text={t('button.updateVideos')} />
          </Button>

          <Button
            isClear
            disabled={isCountingDown || isPending}
            onClick={() => onSync('updateChannel', startCounter)}
            fullWidth>
            <Button.Text text={t('button.updateChannel')} />
          </Button>
        </DropdownMenu>
      }>
      <Button.Text
        text={
          isCountingDown
            ? `${Math.ceil(countdown / 60)} min`
            : t('button.refresh')
        }
      />
      <Button.Icon icon={<PiArrowsClockwise transform='scale(-1,1)' />} />
    </Button>
  );
};

export default ChanelSyncButton;
